import { Pipe, PipeTransform } from '@angular/core';

import { ActivityPerson } from '../../mru/models/activity-description.model';
import { Person } from '../../shared/models/person.model';

@Pipe({
    name: 'activityPersonToPerson'
})
export class ActivityPersonToPersonPipe implements PipeTransform {
    public transform(value: ActivityPerson): Person | undefined {
        if (!value) {
            return undefined;
        }

        return {
            email: value.upn,
            fullName: value.name
        };
    }
}
